var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavLink = function SvgNavLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1677FF",
    fillRule: "evenodd",
    d: "M9.633 4.024c.26.26.26.682 0 .942L4.967 9.633a.667.667 0 1 1-.943-.943L8.69 4.024c.26-.26.683-.26.943 0Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1677FF",
    fillRule: "evenodd",
    d: "M3.057 5.886c.26.26.26.682 0 .942l-.943.943a2.667 2.667 0 0 0 3.772 3.772l.942-.943a.667.667 0 1 1 .943.943l-.943.942a4 4 0 1 1-5.656-5.657l.942-.942c.26-.26.683-.26.943 0ZM6.828 1.172a4 4 0 0 1 5.657 5.656l-.942.943a.667.667 0 1 1-.943-.943l.943-.942A2.667 2.667 0 1 0 7.77 2.114l-.943.943a.667.667 0 1 1-.942-.943l.942-.942Z",
    clipRule: "evenodd"
  })));
};
export default SvgNavLink;